import React, { useState, useEffect, useRef } from 'react';
import './SessionWarningModal.css';

function SessionWarningModal({ isVisible, remainingTime, onExtendSession, onLogout }) {
  const [countdown, setCountdown] = useState(remainingTime);
  const prevVisibleRef = useRef(false);
  const prevRemainingTimeRef = useRef(remainingTime);

  useEffect(() => {
    // Track when modal becomes visible or remainingTime changes
    const justBecameVisible = isVisible && !prevVisibleRef.current;
    const remainingTimeChanged = remainingTime !== prevRemainingTimeRef.current;
    
    prevVisibleRef.current = isVisible;
    prevRemainingTimeRef.current = remainingTime;

    if (!isVisible || remainingTime <= 0) {
      return;
    }

    // Reset countdown when modal just became visible OR when remainingTime prop changes
    if (justBecameVisible || remainingTimeChanged) {
      setCountdown(remainingTime);
    }
      
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isVisible, remainingTime, onLogout]);

  if (!isVisible) {
    return null;
  }

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-header">
          <h3>Session Timeout Warning</h3>
        </div>
        <div className="session-warning-content">
          <p>Your session will expire due to inactivity in:</p>
          <div className="session-countdown">
            {minutes}:{seconds.toString().padStart(2, '0')}
          </div>
          <p>Would you like to extend your session?</p>
        </div>
        <div className="session-warning-actions">
          <button 
            className="extend-session-btn"
            onClick={onExtendSession}
          >
            Extend Session
          </button>
          <button 
            className="logout-btn"
            onClick={onLogout}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionWarningModal;
